import { msg } from '@gonfalon/messages/msg';

import type { AccessCheck } from '../../../types';

export function getAccessRestrictedText({
  access,
  kind,
}: {
  access: AccessCheck;
  kind: 'action' | 'field' | 'setting' | 'token';
}) {
  let text: string | null;

  if (access.isAllowed) {
    return null;
  }

  if (access.customMessage) {
    text = access.customMessage;
  }

  switch (kind) {
    case 'action':
      text = access.appliedRoleName
        ? msg('permissions.accessRestricted.actionDeniedByRole', { roleName: access.appliedRoleName })
        : msg('permissions.accessRestricted.actionDenied');
      break;
    case 'field':
      text = access.appliedRoleName
        ? msg('permissions.accessRestricted.fieldDeniedByRole', { roleName: access.appliedRoleName })
        : msg('permissions.accessRestricted.fieldDenied');
      break;
    case 'setting':
      text = access.appliedRoleName
        ? msg('permissions.accessRestricted.settingDeniedByRole', { roleName: access.appliedRoleName })
        : msg('permissions.accessRestricted.settingDenied');
      break;
    default:
      text = '';
  }

  return text;
}
